// src/store/thunks/user/getMeThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

// Replace 'users' with the correct property name from AppServices, e.g., 'userService'
export const getMeThunk = createAppAsyncThunk(
  "user/getMe",
  async(id:string, { extra: { userService } }) => await userService.getMe(id)
);
